var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "login-container" },
    [
      _vm.status == 0
        ? [_c("Loading", { attrs: { text: "Logging..." } })]
        : [
            _c(
              "div",
              { staticClass: "tips-wrapper" },
              [
                _c("i", { staticClass: "el-icon-warning-outline" }),
                _vm.status == 1
                  ? [
                      _c("span", [
                        _c("p", [_vm._v("Login timeout")]),
                        _c("p", [
                          _vm._v(" Please "),
                          _c(
                            "strong",
                            {
                              staticClass: "link-text",
                              on: { click: _vm.getAuthUrl },
                            },
                            [_vm._v("login")]
                          ),
                          _vm._v(" again. "),
                        ]),
                      ]),
                    ]
                  : [
                      _c("span", [
                        _c("p", { domProps: { innerHTML: _vm._s(_vm.tips) } }),
                        _c("p", [
                          _vm._v(
                            "Please request access from IT administrator."
                          ),
                        ]),
                      ]),
                    ],
              ],
              2
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }